import { OFFER_CONFIG } from "@constants";
import { IProspect } from "@interface/IProspect";

interface IProspectPayload {
    brand: string;
    channelType: string;
    offerType: string;
}

export const getPayload = (): IProspectPayload => ({
    brand: OFFER_CONFIG.BRAND,
    channelType: OFFER_CONFIG.CHANNEL_TYPE,
    offerType: OFFER_CONFIG.OFFER_TYPE,
});

export interface IProspectResponse {
    orderReference: string;
    prospectUuid: string;
}

export const getResponseToState = (response: IProspectResponse): IProspect => ({
    orderReference: response.orderReference,
    prospectUuid: response.prospectUuid,
});

export interface IValidatePortInNumberResponse {
    postpaid: boolean;
    prepaid: boolean;
    success: boolean;
    pendingPortIn: boolean;
}
